// Firebase configuration
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { logFirebaseConfig, logStorageRefDetails } from "../utils/debugUtils";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Initialize Storage with explicit settings
const storage = getStorage(app);
const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;

// Log configuration for debugging
console.log(
  "Firebase initialized with storage bucket:",
  firebaseConfig.storageBucket
);
logFirebaseConfig(app);

// Create a reference to the root of the storage
const storageRef = ref(storage);
console.log("Storage reference created:", storageRef);
logStorageRefDetails(storageRef);

// External bucket information - for direct GCS access
const EXTERNAL_BUCKET_NAME = firebaseConfig.storageBucket;
const EXTERNAL_BUCKET_BASE_URL = `https://storage.googleapis.com/${EXTERNAL_BUCKET_NAME}`;

// Create a reference to a specific file we know exists (for testing)
const testImageRef = ref(
  storage,
  "AktuellesBildistvom08_03_2025__13_21Uhr.jpg"
);
console.log("Test image reference:", testImageRef);
logStorageRefDetails(testImageRef);

// Export the necessary Firebase instances and references
export {
  app,
  auth,
  db,
  storage,
  analytics,
  storageRef,
  testImageRef,
  EXTERNAL_BUCKET_NAME,
  EXTERNAL_BUCKET_BASE_URL,
  getDownloadURL,
};
